<script setup lang="ts">
import './style-editor.css'

const props = defineProps<{ html?: string }>()

const contentHtml = useContentImages(() => props.html)
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-hydrated-html="contentHtml" class="content content-editor" />
</template>
